export default __webpack_public_path__ + "static/media/call.9cd2785d.svg";